export default __webpack_public_path__ + "static/media/San Jose.4617efc7.png";